import { render, staticRenderFns } from "./GiveMedicationModal.vue?vue&type=template&id=813bbfec&scoped=true"
import script from "./GiveMedicationModal.vue?vue&type=script&lang=js"
export * from "./GiveMedicationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813bbfec",
  null
  
)

export default component.exports